
import { PropTypes } from 'prop-types';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';


const SelectedCourses = ({ showSelectedCourse, selectedCourses, clickGoBack }) => {
    const bgs = [
        "hover:bg-[#f9dcc4]",
        "hover:bg-[#ffc8dd]",
        "hover:bg-[#eee4e1]",
        "hover:bg-[#ddf8e8]",
        "hover:bg-[#edc4b3]",

    ]
   
    

  return (
    <div className='flex flex-col w-full pt-8 md:pt-0 items-center'>
      {showSelectedCourse && (
        <div className="flex flex-wrap w-full  lg:w-[64rem] xl:max-w-5xl gap-5 gap-y-8  justify-center items-center py-5 xl:space-x-4">
          {selectedCourses?.map((course, index) => (
            <Link  to={`/all-programmes/${course.path.split('/')[2]}/${course.path.split('/')[3]}`} key={index} className={`flex-shrink-0 w-72 mx-2 p-4 py-7 select-none cursor-pointer bg-white border shadow-md rounded-xl  hover:shadow-xl ${bgs[index]}    transition-all duration-500 `}>
              <div className="p-4 ">
                <p className="text-lg text-center font-semibold">{course.title}</p>
              </div>
            </Link>
          ))}
        </div>
      )}

      {showSelectedCourse && (
        <div className="flex justify-center items-center py-5 space-x-4">
          <div className="text-center">
            <button
              className="bg-white border font-bold border-red-800 text-red-800 px-7 py-3 rounded"
              onClick={clickGoBack}
            >
              Go Back
            </button>
          </div>

          <div className="text-center">
            <Link to={"/all-programmes"}
              className="bg-red-800 text-white px-7 py-3 rounded "
            >
              View All
            </Link>
          </div>
        </div>
      )}
    </div>
  );
};

SelectedCourses.propTypes = {
    showSelectedCourse: PropTypes.bool,
    selectedCourses: PropTypes.array,
    clickGoBack: PropTypes.func,
}
export default SelectedCourses;
